import { z } from 'zod';

export const SupplierUserGroup = {
  SUPPLIER_ADMIN: 'supplier-admin',
  SUPPLIER_SALES: 'supplier-sales',
  SUPPLIER_DELIVERY: 'supplier-delivery',
} as const;

export type SupplierUserGroup = (typeof SupplierUserGroup)[keyof typeof SupplierUserGroup];

export const Permission = {
  VIEW_SOURCING_EVENTS: 'view_sourcing_events',
  SUBMIT_BIDS: 'submit_bids',
  VIEW_SUPPLIER_ORDERS: 'view_supplier_orders',
  UPDATE_DELIVERY: 'update_delivery',
  MANAGE_SUPPLIER_PROFILE: 'manage_supplier_profile',
} as const;

export type Permission = (typeof Permission)[keyof typeof Permission];

export const UserSessionSchema = z.object({
  userId: z.string(),
  email: z.string().email(),
  organizationId: z.string(),
  groups: z.array(z.string()),
  siteAccess: z.array(z.string()),
  venueAccess: z.array(z.string()),
  supplierId: z.string().optional(),
  givenName: z.string().optional(),
  familyName: z.string().optional(),
  phoneNumber: z.string().optional(),
  jobTitle: z.string().optional(),
  preferredLanguage: z.string().optional(),
});

export type UserSession = z.infer<typeof UserSessionSchema>;

export type PortalType = 'internal' | 'supplier';
